<template>
  <div>
    <input
      type="file"
      ref="input_foto"
      v-show="false"
      @change="mudarFoto"
      accept="image/*"
    />
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Galeria</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="mr-2"
            color="primary lighten-3"
            @click="$router.go(-1)"
            :disabled="salvando"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary lighten-5"
            @click="salvar"
            :loading="salvando"
            :disabled="salvando"
            >Salvar</v-btn
          >
        </v-app-bar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="2" class="pb-0">
              <v-text-field
                dense
                label="Código"
                :value="produto.codigo"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="10" class="pb-0">
              <v-text-field
                dense
                label="Código"
                :value="produto.descricao"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-show="loading">
            <v-col
              class="ma-6 pa-6"
              style="display: flex; align-items: center; justify-content: center; text-align: center"
            >
              <v-progress-circular
                size="64"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>

          <v-row v-show="!loading">
            <v-col class="py-0">
              <v-flex xs12>
                <v-card>
                  <v-tabs
                    ref="tabs"
                    left
                    v-model="tab_atual"
                    background-color="primary"
                    slider-color="accent"
                    dark
                  >
                    <v-tab href="#fotos">
                      <v-icon class="mr-4">mdi-image</v-icon>Fotos
                    </v-tab>
                    <v-tab href="#video">
                      <v-icon class="mr-4">mdi-television-play</v-icon>Vídeo
                    </v-tab>
                    <v-spacer />

                    <v-tabs-items v-model="tab_atual">
                      <v-tab-item
                        value="fotos"
                        :transition="false"
                        :reverse-transition="false"
                      >
                        <v-row>
                          <v-col class="pb-0">
                            <span class="ml-4 grey--text"
                              >Limite de 10 fotos por produto</span
                            >
                          </v-col>
                        </v-row>
                        <v-container fluid class="py-0">
                          <v-row>
                            <v-col
                              class="d-flex child-flex"
                              cols="12"
                              xl="2"
                              lg="3"
                              md="4"
                              sm="6"
                              v-show="galeria.fotos.length <= 10"
                            >
                              <v-card
                                class="pa-4"
                                style="display: flex; align-items: center; justify-content: center; text-align: center"
                              >
                                <v-img
                                  :src="blankImg"
                                  aspect-ratio="1"
                                  class="grey lighten-2 white--text align-end"
                                >
                                  <v-card-text class="pa-0 align-center" style="display: flex; flex-direction:column;">
                                    <span
                                      class="primary--text"
                                      style="width: 100%; text-align: center"
                                      >Clique aqui para adicionar uma foto</span
                                    >
                                    <v-btn
                                      rounded
                                      class="ma-2"
                                      color="primary"
                                      style="max-width: 32px;"
                                      @click.stop="carregarFoto"
                                    >
                                      <v-icon>add</v-icon>
                                    </v-btn>
                                  </v-card-text>
                                </v-img>
                              </v-card>
                            </v-col>
                            <v-col
                              v-for="(foto, index) in galeria.fotos"
                              :key="foto"
                              class="d-flex child-flex"
                              cols="12"
                              xl="2"
                              lg="3"
                              md="4"
                              sm="6"
                            >
                              <v-card>
                                <v-img
                                  :src="foto"
                                  :lazy-src="foto"
                                  aspect-ratio="1"
                                  class="grey lighten-2 white--text align-end"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height ma-0"
                                      align="center"
                                      justify="center"
                                    >
                                      <v-progress-circular
                                        indeterminate
                                        color="grey lighten-5"
                                      ></v-progress-circular>
                                    </v-row>
                                  </template>
                                  <v-card-title
                                    class="pa-2"
                                    style="font-size: 1rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block;"
                                  >
                                    <v-btn
                                      fab
                                      small
                                      @click="abrirDialogoExcluirFoto(foto)"
                                      ma-0
                                      color="accent"
                                      style="float: right"
                                    >
                                      <v-icon>delete</v-icon>
                                    </v-btn>
                                    <v-btn
                                      fab
                                      x-small
                                      ma-0
                                      color="accent"
                                      style="font-size: 16px; position: absolute; right: 8px; top: 8px; opacity: 0.7"
                                      >{{ index + 1 }}</v-btn
                                    >
                                  </v-card-title>
                                </v-img>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tab-item>

                      <v-tab-item
                        value="video"
                        :transition="false"
                        :reverse-transition="false"
                      >
                        <v-row>
                          <v-col class="pb-0">
                            <span class="ml-4 grey--text"
                              >Apenas 1 vídeo por produto</span
                            >
                          </v-col>
                        </v-row>

                        <v-container fluid class="py-0">
                          <v-row>
                            <v-col
                              class="d-flex child-flex"
                              cols="12"
                              xl="2"
                              lg="3"
                              md="4"
                              sm="6"
                            >
                              <as-load-video
                                v-model="galeria.video"
                                @onExcluir="galeria.video = ''"
                                @onMensagem="exibirMensagem"
                              ></as-load-video>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-card>
              </v-flex>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <as-dialogo
      ref="dialogoExcluirFoto"
      title="Excluir foto"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Tem certeza que deseja excluir esta foto?</v-label>
      <div class="pa-0 pt-4" style="text-align: right">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluirFoto.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluirFoto"
          :disabled="excluindo"
          :loading="excluindo"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoCrop"
      title="Ajustar Imagem"
      max-width="60vh"
      height="60vh"
    >
      <clipper-fixed
        :src="crop"
        bg-color="white"
        :round="false"
        :rotate="rotation"
        :area="80"
        ref="clipper"
      ></clipper-fixed>
      <v-row class="pt-1">
        <v-col
          cols="12"
          sm="6"
          style="display: flex; align-items: start; justify-content: center; text-align: center; flex-direction: column"
        >
          <v-label>Rotação</v-label>
          <clipper-range
            style="width: 100%; padding: 0px; padding-top: 8px"
            v-model="rotation"
            :min="0"
            :max="360"
          ></clipper-range>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          style="display: flex; align-items: start; justify-content: center; text-align: center; flex-direction: column"
        >
          <v-label>Zoom</v-label>
          <clipper-range
            style="width: 100%; padding: 0px; padding-top: 8px"
            v-model="zoom"
            :min="10"
            :max="200"
          ></clipper-range>
        </v-col>
        <v-col
          cols="12"
          style="align-items: end; display: flex; justify-content: flex-end;"
          class="pb-0"
        >
          <div class="pa-0">
            <v-btn depressed class="mr-4" @click="$refs.dialogoCrop.fechar()"
              >Cancelar</v-btn
            >
            <v-btn depressed color="error" @click="capturarFoto"
              >Confirmar</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </as-dialogo>

    <as-dialogo
      ref="mensagem"
      :title="mensagem.titulo"
      max-width="440px"
      hideCloseButton
    >
      <v-label>{{ mensagem.texto }}</v-label>
      <div class="pa-0 pt-4" style="text-align: right">
        <v-btn depressed @click="$refs.mensagem.fechar()">Fechar</v-btn>
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceProdutos from "../../services/produtos.js";
import { clipperFixed, clipperRange } from "vuejs-clipper";

export default {
  name: "Galeria",
  components: {
    clipperFixed,
    clipperRange,
  },
  data() {
    return {
      blankImg: `data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAH0AfQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AKpg${"A".repeat(
        2047
      )}//9k=`,
      loading: true,
      salvando: false,
      excluindo: false,
      tab_atual: "fotos",
      galeria: {
        fotos: [],
        video: "",
      },
      zoom: 100,
      foto: "",
      crop: "",
      rotation: 0,
      mensagem: {
        titulo: "",
        texto: "",
      },
      produto: {},
      user: {}
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.abrir(this.$route.params.id);
    }
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  methods: {
    async abrir(produtoId) {
      let result = await ServiceProdutos.editar(this.$route.params.id);
      this.produto = result.data.produto;
      this.tab_atual = null;
      this.galeria = {
        fotos: [],
        video: "",
      };
      this.foto = "";
      this.carregarMidia();
    },
    async carregarMidia() {
      this.loading = true;
      try {
        let response = await ServiceProdutos.carregarMidia(this.produto.id);
        this.galeria = response.data.midia;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar a mídia do produto");
      } finally {
        this.loading = false;
        this.$refs.tabs.callSlider();
      }
    },
    carregarVideo() {
      this.$refs.input_video.click();
    },
    mudarVideo() {
      this.galeria.video = "";

      let file = this.$refs.input_video.files[0];

      let reader = new FileReader();
      reader.onload = () => {
        const dataURL = reader.result;

        // 5 Megabytes
        if (this.$refs.input_video.files[0].size > 5242880) {
          this.mensagem.titulo = "Atenção";
          this.mensagem.texto = `Este arquivo de vídeo muito grande - ${(
            this.$refs.input_video.files[0].size /
            1024 /
            1024
          ).toFixed(1)} megabytes! O limite é 5 megabytes.`;
          this.$refs.mensagem.abrir();
        } else {
          this.galeria.video = dataURL;
        }
      };
      reader.readAsDataURL(file);
    },
    metadata() {
      const video = document.getElementById("theVideo");
      const duration = video.duration;
      const height = video.videoHeight;
      const width = video.videoWidth;

      if (video.duration > 31) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto = `A duração deste arquivo de vídeo muito pequena - ${video.duration.toFixed(
          0
        )} segundos! O mínimo é 5 segundos.`;
        this.$refs.mensagem.abrir();
        this.galeria.video = "";
      }

      if (video.duration > 31) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto = `A duração deste arquivo de vídeo muito grande - ${video.duration.toFixed(
          0
        )} segundos! O limite é 30 segundos.`;
        this.$refs.mensagem.abrir();
        this.galeria.video = "";
      }

      if (video.videoHeight < 360 || video.videoWidth < 640) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto = `A resolução deste arquivo de vídeo é baixa - ${video.videoHeight}x${video.videoWidth}! A resolução mínima é de 360x640 pixels.`;
        this.$refs.mensagem.abrir();
        this.galeria.video = "";
      }

      if (video.videoHeight > 1080 || video.videoWidth > 1920) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto = `A resolução deste arquivo de vídeo é muito alta - ${video.videoHeight}x${video.videoWidth}! A resolução máxima é de 1080x1920 pixels.`;
        this.$refs.mensagem.abrir();
        this.galeria.video = "";
      }
    },
    abrirDialogoExcluirVideo() {
      this.$refs.dialogoExcluirVideo.abrir();
    },
    excluirVideo() {
      this.excluindo = true;
      try {
        this.galeria.video = "";
        this.$refs.dialogoExcluirVideo.fechar();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir vídeo");
      } finally {
        this.excluindo = false;
      }
    },
    playVideo() {
      const vid = document.getElementById("theVideo");
      vid.play();
    },
    pauseVideo() {
      const vid = document.getElementById("theVideo");
      vid.pause();
    },
    stopVideo() {
      const vid = document.getElementById("theVideo");
      vid.pause();
      vid.currentTime = 0;
    },
    fullScreen() {
      const vid = document.getElementById("theVideo");
      vid.webkitEnterFullscreen();
    },
    carregarFoto() {
      this.$refs.input_foto.value = null;
      this.$refs.input_foto.click();
    },
    capturarFoto() {
      const canvas = this.$refs.clipper.clip({
        wPixel: 2048,
        maxWPixel: 2048,
      });
      this.galeria.fotos.push(canvas.toDataURL("image/jpeg"));
      this.crop = "";
      this.$refs.dialogoCrop.fechar();
    },
    mudarFoto() {
      let file = this.$refs.input_foto.files[0];

      if (file) {
        let reader = new FileReader();
        reader.onload = () => {
          var dataURL = reader.result;
          this.crop = dataURL;
          this.$refs.dialogoCrop.abrir();

          this.$nextTick(() => {
            this.zoom = 100;
            this.$refs.clipper.onChange$.subscribe((zoom) => {
              if (zoom > 0) {
                this.zoom = zoom * 100 > 200 ? 200 : zoom * 100;
              }
            });
          });
        };
        reader.readAsDataURL(file);
      }
    },
    abrirDialogoExcluirFoto(foto_selecionada) {
      this.foto = this.clone(foto_selecionada);
      this.$refs.dialogoExcluirFoto.abrir();
    },
    excluirFoto() {
      let index = this.galeria.fotos.indexOf(this.foto);

      this.excluindo = true;
      try {
        this.galeria.fotos.splice(index, 1);
        this.$refs.dialogoExcluirFoto.fechar();
        this.foto = "";
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir foto");
      } finally {
        this.excluindo = false;
      }
    },
    async salvar() {
      this.salvando = true;

      try {
        await ServiceProdutos.salvarMidia(this.produto.id, this.galeria);

        this.$eventbus.notificar("Mídia do produto salva com sucesso");

        this.tab_atual = "fotos";
        this.galeria = {
          fotos: [],
          video: "",
        };
        this.foto = "";
        this.$emit("onSalvar");
        if (this.user.tipo == 'master') {
          this.$router.push('/produtos');
        } else {
          this.$router.go(-1);
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao salvar a mídia do produto");
      } finally {
        this.salvando = false;
      }
    },

    exibirMensagem(mensagem) {
      this.mensagem = mensagem;
      this.$refs.mensagem.abrir();
    },
  },
  watch: {
    zoom: {
      handler: function(value) {
        if (!isNaN(value)) {
          this.$refs.clipper.setWH$.next(value / 100);
        }
      },
    },
  },
};
</script>

<style></style>

